module.exports = "<ng-template #navBarTemplate>\n    Instagram Channel Integration\n</ng-template>\n\n<router-outlet></router-outlet>\n"